// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".N5yzf\\+MYNwgfKqDbKVMUfA\\=\\= {\n  font-weight: bold;\n}\n", "",{"version":3,"sources":["webpack://./src/components/Modals/AdminExportModal/AdminExportModal.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB","sourcesContent":[".boldFont {\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boldFont": "N5yzf+MYNwgfKqDbKVMUfA=="
};
export default ___CSS_LOADER_EXPORT___;
